import axios from 'axios';

const searchByZipCode = async (zipCode) => {
	const code = zipCode.replace('-','').replace(' ','');
	return await axios.get(`https://viacep.com.br/ws/${code}/json/`);
};

export default searchByZipCode;
